<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRozpocetStore } from '/@src/stores/rozpocet/useRozpocetStore'
import { computed } from 'vue-demi'
import { formatPercentage, formatMoney } from '/@src/utils/moneyFormatter'
const { t } = useI18n()

const rozpocet = useRozpocetStore()

const celkovaZiadanaSumaPM = computed(() => rozpocet.celkovaZiadanaSumaPM)
const finalSum = computed(() => {
  return (
    (celkovaZiadanaSumaPM.value.sumaEurBezDph || 0) +
    (celkovaZiadanaSumaPM.value.dphEur || 0)
  )
})
const ibaDph = computed(() => celkovaZiadanaSumaPM.value.dphEur)
const bezDph = computed(() => celkovaZiadanaSumaPM.value.sumaEurBezDph)
const opravneneVydavky = computed(() => rozpocet.celkoveOpravneneVydavky.sumaEur)
const ineZdroje = computed(() => rozpocet.ineZdrojeFinancovania.sumaEur)
const vlastneZdroje = computed(() => rozpocet.vlastneZdrojeZiadatela.sumaEur)
const statnyRozpocet = computed(() => rozpocet.statnyRozpocetSumar.sumaEur)
const podielFinancovaniaPMPerc = computed(() => rozpocet.podielFinancovaniaPMPerc.percent)


</script>

<template>
  <IDSKHeading as="h2" variant="l">{{ t('zoppm.step9.section3.heading') }}</IDSKHeading>
  <table class="govuk-table">
    <tbody class="govuk-table__body">
      <tr class="govuk-table__row govuk-table__row--no-border">
        <td class="govuk-table__cell">
          <IDSKHeading as="h4" variant="m" class="mb-0">
            {{ t('zoppm.step9.section3.table.finalSum') }}
          </IDSKHeading>
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          <IDSKHeading as="h4" variant="m">{{ formatMoney(finalSum) }}</IDSKHeading>
        </td>
      </tr>
      <tr class="govuk-table__row govuk-table__row--no-border" v-if="bezDph">
        <td class="govuk-table__cell">
          <div class="ml-4">
            •&nbsp;&nbsp;{{ t('zoppm.step9.section3.table.finalSumNoTax') }}
          </div>
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          {{ formatMoney(bezDph) }}
        </td>
      </tr>
      <tr class="govuk-table__row" v-if="ibaDph">
        <td class="govuk-table__cell">
          <div class="ml-4">
            •&nbsp;&nbsp;{{ t('zoppm.step9.section3.table.finalSumOnlyTax') }}
          </div>
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          {{ formatMoney(ibaDph) }}
        </td>
      </tr>
      <tr class="govuk-table__row" v-if="vlastneZdroje">
        <td class="govuk-table__cell">
          {{ t('zoppm.step9.section3.table.sources') }}
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          {{ formatMoney(vlastneZdroje) }}
        </td>
      </tr>
      <tr class="govuk-table__row">
        <td class="govuk-table__cell">
          <IDSKHeading as="h4" variant="m">{{
            t('zoppm.step9.section3.table.finalExpenses')
          }}</IDSKHeading>
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          <IDSKHeading as="h4" variant="m">{{
            formatMoney(opravneneVydavky)
          }}</IDSKHeading>
        </td>
      </tr>
      <tr class="govuk-table__row" v-if="statnyRozpocet">
        <td class="govuk-table__cell">
          {{ t('zoppm.step9.section3.table.statnyRozpocet') }}
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          {{ formatMoney(statnyRozpocet) }}
        </td>
      </tr>
      <tr class="govuk-table__row" v-if="ineZdroje">
        <td class="govuk-table__cell">
          {{ t('zoppm.step9.section3.table.otherSources') }}
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          {{ formatMoney(ineZdroje) }}
        </td>
      </tr>
      <tr class="govuk-table__row" v-if="typeof podielFinancovaniaPMPerc === 'number'">
        <td class="govuk-table__cell">
          {{ t('zoppm.step9.section3.table.financeShare') }}
        </td>
        <td class="govuk-table__cell" style="text-align: right">
          {{ formatPercentage(podielFinancovaniaPMPerc, 4) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped lang="scss">
.govuk-table__row--no-border .govuk-table__cell {
  border: 0 !important;
}
</style>
